import React from 'react';
import { Field } from "redux-form";

import './TreasureTypeChoice.css'

import {
    TREASURE_TYPE,
   TREASURE_TYPE_TREASURE,
    TREASURE_TYPE_CACHE,
    TREASURE_TYPE_NATURAL,
    TREASURE_TYPE_MANMADE,
} from "../../constants/Game";

export const TreasureTypeChoice = ( props ) => {

    const { treasureType, onChange, useShort } = props;


   const isShort = useShort || window.matchMedia( "(max-width: 500px)" ).matches;

   const natureExplanation = isShort
                    ? "E.g. a tree or river"
                    : "An natural object, not man-made.";
    const manMadeExplanation = isShort
        ? "E.g. a sign or artwork."
        : "A human-made object in its natural surroundings.";
    const cacheExplanation = isShort
        ? "Geocache or placed item."
        : "A geocache or other interesting object you placed.";
    const valuablesExplanation = isShort
       // commented out as these will be used, ore or less, for new category of valuables for each player.
        // ? "E.g. cash or treasure"
        // : "Cash or other valuable prize to be taken.";
       ? "Single prize for winner"
       : "Cash or other prize to be claimed by first winner.";

    return (
        <div className="form-group row">
            <label htmlFor="isPublic" className="col-sm-2 col-form-label">Treasure Type</label>
            <div className="col-sm-9">
                <div>
                    <Field
                       name={TREASURE_TYPE}
                       component="input"
                       type="radio"
                       checked={treasureType === TREASURE_TYPE_TREASURE}
                       onChange={onChange}
                       value={TREASURE_TYPE_TREASURE}
                    />
                    <label className="left-margin set-width-96" htmlFor={TREASURE_TYPE}>
                        Valuables
                    </label>
                    <span className="secondary-text">
                        {valuablesExplanation}
                    </span>
                </div>                <div>
                    <Field
                       name={TREASURE_TYPE}
                       component="input"
                       type="radio"
                       checked={treasureType === TREASURE_TYPE_CACHE}
                       onChange={onChange}
                       value={TREASURE_TYPE_CACHE}
                    />
                    <label className="left-margin set-width-96" htmlFor={TREASURE_TYPE}>
                        Cache
                    </label>
                    <span className="secondary-text">
                        {cacheExplanation}
                    </span>
                </div>
                <div>
                    <Field
                        name={TREASURE_TYPE}
                        component="input"
                        type="radio"
                        checked={treasureType === TREASURE_TYPE_NATURAL}
                        onChange={onChange}
                        value={TREASURE_TYPE_NATURAL}
                    />
                    <label className="left-margin set-width-96" htmlFor={TREASURE_TYPE}>
                        Nature
                    </label>
                    <span className="secondary-text">
                        {natureExplanation} </span>
                </div>
                <div>
                    <Field
                        name={TREASURE_TYPE}
                        component="input"
                        type="radio"
                        checked={treasureType === TREASURE_TYPE_MANMADE}
                        onChange={onChange}
                        value={TREASURE_TYPE_MANMADE}
                    />
                    <label className="left-margin set-width-96" htmlFor={TREASURE_TYPE}>
                        Human-made Object
                    </label>
                    <span className="secondary-text">
                        {manMadeExplanation} </span>
                </div>
            </div>
        </div>
    )
};



// WEBPACK FOOTER //
// ./src/components/huntcomponents/TreasureTypeChoice.js